import type { SportsApi } from "@/v2/api/metadata/sports";
import type { ContentTab, DialogTabSaveContext } from "@/v2/framework/dialog/types";
import { sportsConfigurationSaveRef } from "./configuration/save-ref";

async function save(_ctx: DialogTabSaveContext): Promise<void> {
  if (!sportsConfigurationSaveRef.value) return;
  await sportsConfigurationSaveRef.value();
}

export function createConfigurationTab(options: { sportsApi: SportsApi }): ContentTab {
  const { sportsApi } = options;

  return {
    id: "configuration",
    label: "Configurations",
    save,
    children: [
      {
        type: "component",
        component: () => import("./configuration/SportConfigurationFields.vue"),
        props: { sportsApi },
      },
    ],
  };
}
